import React from 'react';

import type { ExpandedPaymentMethod } from '../shared/types';

import { NameInput } from './components/NameInput';
import { useNameInputWrapper } from './hooks/useNameInputWrapper';

type Props = {
	disabled: boolean;
	paymentType: ExpandedPaymentMethod;
	whiteBackground?: boolean;
};

export const NameInputWrapper: React.FC<Props> = ({ disabled, paymentType, whiteBackground }) => {
	const { data, actions } = useNameInputWrapper(paymentType);
	return <NameInput {...data} {...actions} disabled={disabled} whiteBackground={whiteBackground} />;
};
